import React, { useState } from "react";
import CreateCoin from "../Components/Modal/CreateCoin";
import CustomBg from "../Components/CustomBg";
import { coins } from "../constants";

const Home = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Function to open the modal
  const openModal = () => {
    setIsModalOpen(true);
  };

  // Function to close the modal
  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="home-trending-coin">
      <CustomBg />
      <div className="home-header">
        <h2>Recent Trending Coin</h2>
        <div className="home-featured-coin">
          <img src="Rectangle.png" alt="Profile" /> {/* Replace with actual file */}
          <div>
            <h3>Mind Bath(MB)</h3>
            <p className="created-by">Created By: @musauk</p>
            <p className="market-cap">Market Cap: $73K</p>
            <p className="replies">Replies: 45</p>
            <p className="time-stam">23 min Ago</p>
          </div>
        </div>
        <div className="btn-center">
          <button className="home-start-btn" onClick={openModal}>
            <img className="wallet-img" src="coin.png" alt="User" /> Start a New Coin
          </button>
        </div>
      </div>

      {/* Search and Sort Section */}
      <div className="home-toolbar">
        <div className="home-sort">
          <label htmlFor="sort">Sort By:</label>
          <select id="sort">
            <option value="featured">Featured</option>
            <option value="recent">Recent</option>
          </select>
        </div>
        <input className="home-search" type="text" placeholder="Search for Tokens" />
      </div>

      {/* Coins List Section */}
      <div className="home-coin-list">
        {coins.map((coin) => (
          <div key={coin.id} className="home-coin-card">
            <div className="coin-card-left">
              <img src={coin.image} alt="Coin" className="coin-image" />
            </div>
            <div className="coin-card-right">
              <h3 className="coin-title">{coin.title}</h3>
              <p className="coin-creator">Created by: <span>{coin.creator}</span></p>
              <p className="coin-time-ago">{coin.timeAgo}</p>
              <div className="coin-stats">
                <p className="market-cap">Market Cap: $73K</p>
                <p className="coin-replies">Replies: <span>{coin.replies}</span></p>
              </div>
              <p className="coin-description">{coin.description}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Render Modal if open */}
      {isModalOpen && <CreateCoin onClose={closeModal} />}
    </div>
  );
};

export default Home;
